import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import CreatePackage from "./CreatePackage";

const CreatePackageLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Create Package" />
      <CreatePackage />
    </MasterLayout>
  );
};

export default CreatePackageLayout;
